// Reine Logik + Konstanten für den Möbel-Katalog. Keine Supabase-Abhängigkeit,
// damit hier sauber getestet werden kann (der Service-Layer nutzt diese Helfer).

export const FURNITURE_STYLES = ['modern', 'luxury', 'industrial'] as const;
export type FurnitureStyle = (typeof FURNITURE_STYLES)[number];

export const FURNITURE_ROOM_TYPES = [
  'living', 'bedroom', 'dining', 'kitchen', 'bathroom',
  'office', 'hallway', 'staircase', 'closet', 'balcony', 'terrace',
] as const;
export type FurnitureRoomType = (typeof FURNITURE_ROOM_TYPES)[number];

export const FURNITURE_ROOM_LABELS: Record<string, string> = {
  living: 'Wohnzimmer',
  bedroom: 'Schlafzimmer',
  dining: 'Esszimmer',
  kitchen: 'Küche',
  bathroom: 'Badezimmer',
  office: 'Arbeitszimmer',
  hallway: 'Flur / Diele',
  staircase: 'Treppenhaus',
  closet: 'Ankleidezimmer',
  balcony: 'Balkon',
  terrace: 'Terrasse',
};

// Vorschlagsliste (datalist) für den Kategorie-Freitext im Bibliothek-Editor.
// Admins können auch eigene Kategorien tippen — dies sind nur Vorschläge.
export const FURNITURE_CATEGORIES = [
  'sofa',
  'ecksofa',
  'sessel',
  'hocker',
  'couchtisch',
  'couchtisch_klein',
  'beistelltisch',
  'esstisch',
  'esszimmerstuhl',
  'stuhl',
  'barhocker',
  'bett',
  'nachttisch',
  'kleiderschrank',
  'kommode',
  'sideboard',
  'tv_board',
  'regal',
  'buecherregal',
  'schreibtisch',
  'buerostuhl',
  'garderobe',
  'teppich',
  'stehlampe',
  'tischlampe',
  'deckenlampe',
  'pflanze',
  'vase',
  'wandbild',
  'spiegel',
  'vorhang',
  'deko',
] as const;
export type FurnitureCategory = (typeof FURNITURE_CATEGORIES)[number];

export function isFurnitureStyle(v: string): v is FurnitureStyle {
  return (FURNITURE_STYLES as readonly string[]).includes(v);
}

export function isFurnitureRoomType(v: string): v is FurnitureRoomType {
  return (FURNITURE_ROOM_TYPES as readonly string[]).includes(v);
}

export function isFurnitureCategory(v: string): v is FurnitureCategory {
  return (FURNITURE_CATEGORIES as readonly string[]).includes(v);
}

export function fileExt(file: { type: string }): 'png' | 'jpg' {
  return file.type === 'image/png' ? 'png' : 'jpg';
}

export function furnitureStoragePath(id: string, ext: string): string {
  return `furniture-catalog/library/${id}.${ext}`;
}

/** Reine Reorder-Funktion: bewegt Element von `from` nach `to`, gibt neue Liste zurück.
 *  Out-of-range Indizes → unveränderte Kopie. */
export function moveItem<T>(arr: readonly T[], from: number, to: number): T[] {
  const copy = [...arr];
  if (from < 0 || from >= copy.length || to < 0 || to >= copy.length) return copy;
  const [moved] = copy.splice(from, 1);
  copy.splice(to, 0, moved);
  return copy;
}
